import React from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import "./PopupStyle.css"
interface CustomAlertProps {
  isHeading?: boolean,
  errorCount: number;
  messages: string[]; // Array of error messages
  onClose: () => void; // Close function
}

const CustomAlert: React.FC<CustomAlertProps> = ({ errorCount, messages, onClose }) => {

  if (messages.length === 0) return null; // Hide if no errors

  return (
    <div className="fullscreen-loader">
      <div className="modal show" style={{ display: 'block', position: 'relative' }}>
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>{`Please resolve the below ${errorCount > 2 ? "issues" : "issue"} to move forward.`}</Modal.Title>
          </Modal.Header>


          <Modal.Body>
            {/* <h2> */}
            {messages.map((msg, index) => (
              <p className="text-start text-left" key={index} style={{ fontSize: "15px" }}>
                {index + 1} - {msg}
              </p>
            ))}
            {/* </h2> */}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={onClose} style={{ color: "black", border: "1px black solid" }}> Close </Button>
          </Modal.Footer>
        </Modal.Dialog>
      </div>
    </div>

  );
};

export default CustomAlert;
